import { initialState, ErrorState } from "./ErrorStore";
import { createAction } from "typesafe-actions";
import { GeneralExceptionResponse, ValidationExceptionResponse } from "../../../elev/generated/types/error";

enum ErrorTypes {
	CLEAR_ERROR = "CLEAR_ERROR",
	SET_ERROR = "SET_ERROR"
}

export const SetErrorAction = createAction(ErrorTypes.SET_ERROR)<
	GeneralExceptionResponse | ValidationExceptionResponse
>();
export const ClearErrorAction = createAction(ErrorTypes.CLEAR_ERROR)();

export type ErrorActionType = ReturnType<typeof SetErrorAction> | ReturnType<typeof ClearErrorAction>;

export const ErrorReducer = (state: ErrorState, action: ErrorActionType): ErrorState => {
	switch (action.type) {
		case ErrorTypes.CLEAR_ERROR:
			return {
				...initialState
			};
		case ErrorTypes.SET_ERROR:
			return {
				...state,
				error: action.payload
			};
		default:
			return state;
	}
};
